import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
// import NextOfKin from './NextOfKin';
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { config } from "../_helpers/global";
import { NewbornSidebar } from "../Layouts/NewbornSidebar";

import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class NewbornReferral extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      motherName: "",
      Gravidapara: "",
      dateofbirth: "",
      timeofbirth: "",
      prolongedlabor: "",
      estimatedGestationalage: "",
      NormalDeliveryStatus: "",
      CSIndication: "",
      deliveryMedication: "",
      illness: "",
      APGAR1: "",
      APGAR5: "",
      APGAR10: "",
      Baggingdone: "",
      minutesNumber: "",
      prereferralTreatment: "",
      response: "",
      loading: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    this.setState({
      uniqid: (Math.random() + 1).toString(36).substring(7),
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  getTableValues(event) {
    this.formatTableOutput(event);
  }

  formatTableOutput(data) {
    // console.log(data);
    let tableobj = {}; //empty obj
    for (let i = 0; i < data.length; i++) {
      let tempobj = {};
      tempobj["Date"] = data[i][0];
      tempobj["Type Of Investigation"] = data[i][1];
      tempobj["Results"] = data[i][2];
      tempobj["Normal range"] = data[i][3];
      tableobj[i] = tempobj;
    }
    this.state.labResults = JSON.stringify(tableobj);
  }

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      "Access-Control-Allow-Origin": "*",
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    let payload = {
      motherName: this.state.motherName,
      Gravidapara: this.state.Gravidapara,
      dateofbirth: this.state.dateofbirth,
      timeofbirth: this.state.timeofbirth,
      prolongedlabor: this.state.prolongedlabor,
      estimatedGestationalage: this.state.estimatedGestationalage,
      NormalDeliveryStatus: this.state.NormalDeliveryStatus,
      CSIndication: this.state.CSIndication,
      deliveryMedication: this.state.deliveryMedication,
      illness: this.state.illness,
      APGAR:
        "(" +
        this.state.APGAR1 +
        "," +
        this.state.APGAR5 +
        "," +
        this.state.APGAR10 +
        ")",
      Baggingdone: this.state.Baggingdone,
      minutesNumber: this.state.minutesNumber,
      prereferralTreatment: this.state.prereferralTreatment,
    };

    // console.log(payload);

    axios
      .post(this.api_url+"referral/postnatal", payload, {
        headers: headers,
      })
      .then((response) => {
        // console.log(response)
        this.setState({ response: response });
        if (response.status == 200) {
          $("#SubmitError").fadeOut("fast");
          $(".alert-success").show();
          setTimeout(function (props) {
            // window.location.href = '/newbornunit/procedures'
          }, 1000);
        } else {
          $(".alert-success").fadeOut("fast");
          $("#SubmitError").show();
        }
      })
      .catch((error) => {
        this.state.loading = false;
        $(".alert-success").fadeOut("fast");
        $("#SubmitError").show();
        console.log(error);
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      motherName,
      Gravidapara,
      dateofbirth,
      timeofbirth,
      prolongedlabor,
      estimatedGestationalage,
      NormalDeliveryStatus,
      CSIndication,
      deliveryMedication,
      illness,
      APGAR1,
      APGAR5,
      APGAR10,
      Baggingdone,
      minutesNumber,
      prereferralTreatment,
      loading,
    } = this.state;

    const data = [["", "", "", ""]];
    const columns = [
      "Date",
      "Type Of Investigation",
      "Results",
      "Normal range",
    ];

    return (
      <div>
        {/* <NextOfKin userData = {response}/> */}
        <Headers />
        <NewbornSidebar></NewbornSidebar>

        <main className="content-container">
          <div className="container pl-4">
            <div className="row pl-2 text-lg-center font-weight-bold p-1">
              <p className="text-capitalize" style={font16}>
                Referral form from maternity to NICU
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      {" "}
                      Mother's Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={motherName}
                      name="motherName"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      {" "}
                      Gravida/para:
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Gravidapara}
                      name="Gravidapara"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Date Of Birth:
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={dateofbirth}
                      name="dateofbirth"
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Time Of Birth (24 Hrs):
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={timeofbirth}
                      name="timeofbirth"
                      type="time"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Prolonged labor? PROM (18hrs) Meconium?:
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={prolongedlabor}
                      name="prolongedlabor"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Estimated Gestational age?
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={estimatedGestationalage}
                      name="estimatedGestationalage"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      {" "}
                      Mode of Delivery
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      name="NormalDeliveryStatus"
                    >
                      <optgroup label="">
                        <option selected value=""></option>
                        <option value="Normal delivery">Normal delivery</option>
                        <option value="Vacuum">Vacuum</option>
                        <option value="Vacuum">Forceps</option>
                        <option value="Vacuum">Breech</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      C/S?
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={CSIndication}
                      name="CSIndication"
                    >
                      <optgroup label="CSIndication">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                {/* <div className="col-md-12 p-2">
                                    <div className="py-1">
                                        <h6 className="text-capitalize " style={fontFamilyNunito}>Indication For CS</h6>
                                        <input className="form-control" onChange={this.handleChange} value={history} name="name" type="text" required />
                                    </div>
                                </div> */}
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Any medication given to the mother during delivery?
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={deliveryMedication}
                      name="deliveryMedication"
                    >
                      <optgroup label="deliveryMedication">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">
                      Does the mother have any illness e.g., Diabetes,
                      hypertension? Infection?
                    </h6>
                    <textarea
                      className="form-control"
                      name="illness"
                      onChange={this.handleChange}
                      value={illness}
                      type="text"
                      rows="6"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      APGAR 1min:
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={APGAR1}
                      name="APGAR1"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      APGAR 5min:
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={APGAR5}
                      name="APGAR5"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      APGAR 10min:
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={APGAR10}
                      name="APGAR10"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Bagging done?{" "}
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Baggingdone}
                      name="Baggingdone"
                    >
                      <optgroup label="Baggingdone">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">How many minutes?</h6>
                    <input
                      className="form-control"
                      name="minutesNumber"
                      type="text"
                      onChange={this.handleChange}
                      value={minutesNumber}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Any other treatment given at maternity/OT before referral?
                    </h6>
                    <textarea
                      className="form-control"
                      name="prereferralTreatment"
                      rows="6"
                      onChange={this.handleChange}
                      value={prereferralTreatment}
                      type="text"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading == false ? (
                      <span>Submit</span>
                    ) : (
                      <span>Loading</span>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewbornReferral;
